import type { MutableRefObject } from 'react';

export default function getParentSizeFromRef(
    svgRef: MutableRefObject<SVGSVGElement>,
): { parentWidth: number; parentHeight: number } | null {
    const svg = svgRef.current;
    if (!svg) {
        return null;
    }
    const parentWidth = svg.parentElement?.clientWidth || 0;
    const parentHeight = svg.parentElement?.clientHeight || 0;
    return !parentWidth || !parentHeight ? null : { parentWidth, parentHeight };
}
